import { ConsultationRequestError } from '@errors/consultation-request-error';

export class ConsultationRequestInvalidLinkError extends ConsultationRequestError {
  public constructor(contact: string) {
    super(`The link is no longer valid. Please contact customer service at ${contact} for assistance.`);
  }
}
